<template>
  <fragment>
    <!-- Statistic -->

    <content-placeholders :rounded="true">
      <div class="row">
        <!-- <div
          v-for="(n, index) in forPlaceholder.card"
          :key="index + 5"
          :class="'col-xl changerSize forPlaceholder ' + 'sc' + (index + 5)"
        > -->
        <!-- card cuman sebagai patokan perulangan -->
        <!-- <div class="card mini-stats-wid" style="width: 100%">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <content-placeholders-text :lines="1" style="width: 100px" />
                  <content-placeholders-text :lines="1" style="width: 100px" />
                </div>

                <div
                  class="mini-stat-icon avatar-sm rounded-circle text-primary align-self-center"
                >
                  <content-placeholders-img />
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div
          v-for="(card, index) in attrDash.card"
          :key="index"
          :class="'col-xl changerSize ' + 'sc' + index"
        >
          <div class="card mini-stats-wid" style="width: 100%">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-muted fw-medium">{{ card.title }}</p>
                  <h4 class="mb-0 stats-text">{{ card.total }}</h4>
                </div>

                <div
                  class="
                    mini-stat-icon
                    avatar-sm
                    rounded-circle
                    text-primary
                    align-self-center
                  "
                >
                  <span class="avatar-title" v-html="card.icon"> </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6">
          <div class="card mini-stats-wid" style="width: 100%">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-muted fw-medium">
                    {{ complaintProduct.title }}
                  </p>

                  <p class="text-muted mt-0">Total Product:</p>
                  <h4 class="mb-0 stats-text mt-0">
                    {{ complaintProduct.totalData }}
                  </h4>

                  <p class="text-muted mt-0">Total Harga:</p>
                  <h4 class="mb-0 stats-text mt-0">
                    {{ complaintProduct.total }}
                  </h4>
                </div>

                <div
                  class="
                    mini-stat-icon
                    avatar-sm
                    rounded-circle
                    text-primary
                    align-self-center
                  "
                >
                  <span class="avatar-title">
                    <i class="now-ui-icons shopping_cart-simple"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6">
          <div class="card mini-stats-wid" style="width: 100%">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-muted fw-medium">
                    {{ taxProduct.title }}
                  </p>

                  <p class="text-muted mt-0">Total Product:</p>
                  <h4 class="mb-0 stats-text mt-0">
                    {{ taxProduct.totalData }}
                  </h4>

                  <p class="text-muted mt-0">Total Harga:</p>
                  <h4 class="mb-0 stats-text mt-0">
                    {{ taxProduct.total }}
                  </h4>
                </div>

                <div
                  class="
                    mini-stat-icon
                    avatar-sm
                    rounded-circle
                    text-primary
                    align-self-center
                  "
                >
                  <span class="avatar-title">
                    <i class="now-ui-icons shopping_cart-simple"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6">
          <div class="card card-chart" id="wilayahDivBar">
            <div class="card-header mt-2" style="font-weight: 700">
              <h4 class="card-title">Persebaran Wilayah</h4>
            </div>
            <div class="text-center mb-5 p-3" v-if="countWilayah === 0">
              <img
                src="./emptyState.jpg"
                class="img-responsive mb-4 img-flud img-container"
                height="150px"
                alt=""
              />
              <p class="text-muted">Belum ada data</p>
            </div>
            <div v-else class="card-body mb-5 mt-4 text-center">
              <div
                class="chart-container"
                style="position: relative; height: auto; width: 90%"
              >
                <canvas id="wilayahChart"></canvas>
              </div>
              <div class="mt-3"></div>
              <div class="table-responsive mt-4">
                <table class="table align-middle table-nowrap table-condensed">
                  <thead>
                    <tr class="table-condensed">
                      <th>Wilayah</th>
                      <th>Jumlah</th>
                      <th>Nilai</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="wilayah in sectionStatistic.areaDistribution"
                      :key="wilayah.id"
                      class=""
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="'Jumlah Transaksi :' + wilayah.total"
                    >
                      <td class="text-center" style="width: 30%">
                        <p class="mb-0 text-muted" style="font-size: 11px">
                          {{ wilayah.province }}
                        </p>
                      </td>
                      <td style="width: 30%">
                        <h5 class="mb-0" style="font-size: 11px">
                          {{ wilayah.total }}
                        </h5>
                      </td>
                      <td class="text-center" style="width: 50%">
                        <p class="mb-0 text-muted" style="font-size: 11px">
                          {{ wilayah.valueCurrencyFormat }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6">
          <div class="card card-chart">
            <div class="card-header mt-2" style="font-weight: 700">
              <h4 class="card-title">Sekolah Populer</h4>
            </div>
            <div class="text-center mb-5 p-3" v-if="countWilayah === 0">
              <img
                src="./emptyState.jpg"
                width="250px"
                class="img-responsive img-flud img-container"
                alt=""
              />
              <p class="text-muted">Belum ada data</p>
            </div>
            <div v-else class="card-body mb-5 mt-4">
              <div
                class="chart-area chart-container"
                style="position: relative; height: 150px; width: 100%"
              >
                <canvas
                  id="sekolahPopulerChart"
                  width="100%"
                  height="30px"
                ></canvas>
              </div>
              <div class="table-responsive mt-4">
                <table class="table align-middle table-nowrap table-condensed">
                  <thead>
                    <tr class="table-condensed">
                      <th>Sekolah</th>
                      <th>Kota</th>
                      <th>Jumlah Pesan</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="sekolah in sectionStatistic.popularSchool"
                      :key="sekolah.id"
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="'Jumlah Transaksi :' + sekolah.total"
                    >
                      <td class="text-left" style="width: 30%">
                        <p class="mb-0 text-muted" style="font-size: 11px">
                          {{ sekolah.name }}
                        </p>
                      </td>
                      <td style="width: 30%">
                        <h5 class="mb-0" style="font-size: 11px">
                          {{ sekolah.city }}
                        </h5>
                      </td>
                      <td class="text-left" style="width: 50%">
                        <p class="mb-0 text-muted" style="font-size: 11px">
                          {{ sekolah.total }} pcs
                        </p>
                      </td>
                      <td>
                        <div class="progress bg-transparent progress-sm">
                          <div
                            class="progress-bar text-primary rounded"
                            role="progressbar"
                            style="
                              background-color: #3bb78f;
                              background-image: linear-gradient(
                                315deg,
                                #3bb78f 0%,
                                #0bab64 74%
                              );
                              width: 100%;
                            "
                            aria-valuenow="isi"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card card-chart" style="" id="wilayahDivBar">
            <div class="card-header mt-2" style="font-weight: 700">
              <h4 class="card-title">Nomor Rekening</h4>
            </div>
            <div class="card-body mt-4 text-center">
              <i
                class="fas fa-money-check text-primary filterImg"
                style="font-size: 40px"
                aria-hidden="true"
              ></i>

              <div class="card-group text-left">
                <div
                  v-for="(acc, index) in account"
                  :key="index"
                  class="card"
                  style="box-shadow: none"
                >
                  <div class="card-body">
                    <form>
                      <div class="mb-3">
                        <div id="" class="form-text">
                          REKENING BANK {{ index + 1 }}
                        </div>
                        <label for="" class="form-label">Nama Bank :</label>
                        <input
                          :disabled="disabledEdit"
                          type="text"
                          class="form-control"
                          id=""
                          aria-describedby=""
                          :value="acc.bank"
                        />
                      </div>
                      <div class="mb-3">
                        <label for="" class="form-label"
                          >Nomor Rekening :</label
                        >
                        <input
                          :disabled="disabledEdit"
                          type="text"
                          class="form-control"
                          id=""
                          :value="acc.number"
                        />
                      </div>
                      <div class="mb-3">
                        <label for="" class="form-label">Atas Nama :</label>
                        <input
                          :disabled="disabledEdit"
                          type="text"
                          class="form-control"
                          id=""
                          :value="acc.asName"
                        />
                      </div>
                      <!-- <button
                        type="button"
                        class="btn btn-primary"
                        id="updateNorek"
                      >
                        Update
                      </button> -->
                      <p v-if="disabledEdit" class="text-muted font-italic">
                        Untuk mengganti Akun Bank mohon hubungi CS EUREKA
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </content-placeholders>
  </fragment>
</template>

<script>
import $ from "jquery";
import { ChartWilayah } from "/src/ChartComponents/ChartWilayah.js";
import { SekolahChart } from "/src/ChartComponents/ChartSekolah.js";
import axios from "axios";

// import { sleeper } from "/src/utils/sleeper.js";
export default {
  data() {
    return {
      fakeLooping: 5,
      attrDash: [],
      sectionStatistic: {},
      forPlaceholder: {},
      account: {},
      countWilayah: "",
      disabledEdit: true,
      complaintProduct: [],
      taxProduct: [],
    };
  },
  created() {
    this.attrDashboard();
  },
  methods: {
    attrDashboard() {
      let dashboardUrl = "seller/dashboard";
      axios
        .get(dashboardUrl)
        .then((response) => {
          this.forPlaceholder = response.data.data;
          return response;
        })
        // .then(sleeper(800))
        .then((response) => {
          // console.log(response.data.data)
          return response.data.data;
        })
        .then((data) => {
          // console.log(data.taxProduct)
          $(".forPlaceholder").remove();
          $(".vue-content-placeholders-text").remove();
          $(".vue-content-placeholders-img").remove();
          this.attrDash = data;
          this.complaintProduct = data.complaintProduct;
          this.taxProduct = data.taxProduct;
          this.sectionStatistic = data.sectionStatistic;
          this.countWilayah = data.sectionStatistic.areaDistribution.length;

          this.account = data.account;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted: function () {
    ChartWilayah(), SekolahChart();
    // const matchSize = window.screen.availWidth;
    // if (matchSize > 1792) {
    //   $("#cardPlus").removeAttr("hidden");
    //   $(".changerSize").removeClass("col-lg-2").addClass("col-lg");
    // }
    // $(window).on("resize", function () {
    //   if ($(window).width() > 1792) {
    //     $(".changerSize").addClass("col-lg").removeClass("col-lg-2");
    //     $("#cardPlus").removeAttr("hidden");
    //   } else {
    //     $(".changerSize").addClass("col-lg").removeClass("col-lg-2");
    //     $("#cardPlus").attr("hidden", "");
    //   }
    // });
    // if (matchSize < 1792) {
    //   setTimeout(() => {
    //     $(".sc3").hide();
    //   }, 400);
    // }
    // $(window).on("resize", function () {
    //   if ($(window).width() < 1792) {
    //     setTimeout(() => {
    //       $(".sc3").hide();
    //     }, 200);
    //     $(".changerSize").addClass("col-lg").removeClass("col-lg-2");
    //     $("#cardPlus").removeAttr("hidden");
    //   } else {
    //     $(".changerSize").addClass("col-lg").removeClass("col-lg-2");
    //     $("#cardPlus").attr("hidden", "");
    //   }
    // });
  },
};
</script>

<style scoped>
.table {
  width: 100%;
}

@media (max-width: 1410px) {
  .table {
    width: 100%;
  }
}

@media (max-width: 517px) {
  .table {
    width: 100%;
  }
}
</style>

